import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getMonthLocksAPI, getYearOptionsAPI, lockMonthAPI, updateMonthlockAPI } from "./endpoints";

function* getYearOptionsSaga(action) {
  try {
    const _api = yield call(getYearOptionsAPI, action.payload);
    yield put(actions.setYearOptions(_api.data.results));
  } catch (error) {
    console.log(error);
  }
}

function* getMonthLocksSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getMonthLocksAPI, action.payload);
    yield put(actions.setMonthLocks(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* lockMonthSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(lockMonthAPI, action.payload?.payload);
    if (_api?.data?.success) {
      yield put(actions.getMonthLocks(action.payload?.filters || {}));
      yield put(
        commonActions.setAlert({
          message: _api?.data?.message,
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Failed",
        alertType: "error",
        showToast: true,
      })
    );
    console.log(error);
  }
}

function* updateMonthlockSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(updateMonthlockAPI, action.payload?.payload);
    if (_api?.data?.success) {
      yield put(actions.getMonthLocks(action.payload?.filters || {}));
      yield put(
        commonActions.setAlert({
          message: _api?.data?.message,
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Failed",
        alertType: "error",
        showToast: true,
      })
    );
    console.log(error);
  }
}

export function* withMonthLocksSaga() {
  yield all([
    takeEvery(actionTypes.GET_YEAR_OPTIONS, getYearOptionsSaga),
    takeEvery(actionTypes.GET_MONTH_LOCKS, getMonthLocksSaga),
    takeEvery(actionTypes.LOCK_MONTH, lockMonthSaga),
    takeEvery(actionTypes.UPDATE_MONTHLOCK, updateMonthlockSaga),
  ]);
}
